<template>
  <div>
    <div class="row  pl-4 pr-4">
      <div :class="editando ? 'col-md-6' : 'col-md-4'">
        <label>{{ $t("nombre") }}</label>
        <input
          type="text"
          class="form-control"
          :class="{
            'is-invalid': $v.misDatos.name.$error,
            'is-valid': !$v.misDatos.name.$invalid,
          }"
          v-model="misDatos.name"
        />
      </div>
      <div :class="editando ? 'col-md-6' : 'col-md-4'">
        <label>{{ $t("apellidos") }}</label>
        <input
          class="form-control"
          type="text"
          :class="{
            'is-invalid': $v.misDatos.lastname.$error,
            'is-valid': !$v.misDatos.lastname.$invalid,
          }"
          v-model="misDatos.lastname"
        />
      </div>
      <div class="col-md-4" v-if="!editando">
        <label>
          {{ $t("mis criadores") }}
        </label>
        <select v-if="!editando" @change="seleccionarMiCriador($event)">
          <option>{{$t('seleccionar criador')}}</option>
           <option v-for="c in misCriadores" :key="c.id" :value="c.id">{{
             `${c.name} ${c.lastname}` 
            }}</option>
        </select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button
          class="btn btn-sm btn-success miBtn mr-0 float-right my-auto"
          @click.prevent="guardarRegistro"
        >
          {{ $t("guardar") }}
        </button>
        <button
          class="btn btn-sm miBtn mr-1 float-right my-auto"
          @click.prevent="cancelar"
        >
          {{ $t("cancelar") }}
        </button>
      </div>
    </div>
    <div class="row" v-if="!!notificacion.texto">
      <div
        class="col-12 text-center"
        :class="notificacion.tipo"
        v-html="notificacion.texto"
      ></div>
    </div>
    {{ editando }}
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import Vuelidate from "vuelidate";
import { formatearNombres } from "@/_helpers/index";
import {
  required,
  minLength,
  maxLength,
  between,
} from "vuelidate/lib/validators";
Vue.use(Vuelidate);

export default {
  name: "Dog-criador",
  props: ["datos", "listaCriadores"],
  data: () => ({
    misDatos: {
      id: null,
      name: null,
      lastname: null,
      dog_id: null,
    },
    titulo: "alta nuevo criador",
    listing: false,
    notificacion: {
      tipo: "text-danger",
      texto: null,
    },
    editando: false,
    editandoId: null,
    misCriadores: null
  }),
  validations: {
    misDatos: {
      name: { required },
      lastname: { required },
    },
  },
  methods: {
    ...mapActions("coprop", ["acBuscarUsuarioPorDni"]),
/*  */
    guardarRegistro() {
      this.$v.$touch();
      console.log(this.$v.$invalid);
      if (this.$v.$invalid) {
        return;
      } 
      //formateamos los datos
      this.misDatos.name =  formatearNombres(this.misDatos.name);
      this.misDatos.lastname = formatearNombres(this.misDatos.lastname);

      this.$emit("emitAltaCriador", {
        datos: this.misDatos,
        editando: this.editando,
        id: this.editandoId,
      });
    },
    cancelar: function() {
      this.editando = false;
      this.$emit("emitCancelar");
    },
    /* funcion para seleccionar un criador de mi lista, solo para nuevos no se muestra al editar */
    seleccionarMiCriador(c) {
      const miC = c.target.value;
      if(!c) return;
      const tmp = this.listaCriadores.find(cr => cr.id === parseInt(miC));
      console.log(miC, tmp, this.listaCriadores);
      //return;
      this.misDatos.id = tmp.id;
      this.misDatos.name = tmp.name;
      this.misDatos.lastname = tmp.lastname;
    }
  },
  mounted() {
    //si hay datos
    if (!!this.datos) {
      console.log("hay datos", this.datos, !this.datos);
      this.editando = true;
      this.editandoId = this.datos.editid;
      //clonamos el objeto
      this.misDatos = Object.assign(this.misDatos, this.datos);
    }
    console.log(this.listaCriadores)
    this.misCriadores = _.cloneDeep(this.listaCriadores)
  },
};
</script>

<style scoped>
div.col-md-4 {
  padding: 0px 5px 0px 5px !important;
}
input,
select {
  padding: 1px 0px 0px 10px !important;
  height: 28px;
  background-color: white;
  color: black !important;
}
input:focus {
  background-color: seashell;
  color: blue !important;
}
button.miBtn {
  min-width: 50px;
}
.pos-botones {
  margin-top: 28px;
}
select {
  height: 28px !important;
  font-size: 0.8em;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
</style>
